import React, { useMemo } from 'react'
import {
  Box,
  Text,
  IcoMoon,
  CheckIcon,
} from '@usap/uicomponents'

const SuccessMedium = props => {
  const {
    message,
  } = props

  const innerHtml = useMemo(() => ({
    __html: message,
  }),
  [message])

  const style = useMemo(
    () => ({
      containerBorder: { color: 'green', side: 'all' },
      containerBorderLeftWidth: { borderLeftWidth: '6px' },
      containerMargin: { vertical: 'small' },
      iconWrapperWidth: { minWidth: 34 },
      innerHtmlWrapper: { left: 'small' },
    }),
    [],
  )

  return (
    <Box pad="small">
      <Box
        direction="row"
        border={style.containerBorder}
        style={style.containerBorderLeftWidth}
        pad="small"
        margin={style.containerMargin}
      >
        <Box align="center" justify="center" style={style.iconWrapperWidth}>
          <Box
            justify="center"
            align="center"
            margin="xsmall"
            width="34px"
            height="34px"
            round="50%"
            background="green"
            border={null}
          >
            <IcoMoon icon={CheckIcon} color="white" size="24px" />
          </Box>
        </Box>
        <Box alignSelf="center" pad={style.innerHtmlWrapper} width="100%">
          <Text
            size="small"
            color="dark-2"
            dangerouslySetInnerHTML={innerHtml}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default SuccessMedium
